import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SeeMeItem from './SeeMeItem';
import Loading from '../common/Loading.js';
import ErrorMessage from '../common/ErrorMessage';

class SeeMe extends React.Component {
    constructor(props, context) {
        super(props, context);
     }

    componentDidMount() {  
        if((!this.props.artist.Gigs && !this.props.artist.GigsStatus) || this.props.artist.GigsStatus === 'FAILED') {
            this.props.actions.getGigs(this.props.artist.Username);
        }
    }

    render() {
        const artist = this.props.artist;
        const actions = this.props.actions;
        return (
            artist.GigsStatus === 'FAILED' ?
                <ErrorMessage error="Sorry, something went wrong! Unable to load gigs." />
                :
                <div>
                    <div className="table-info visible-xs">&#8592; SCROLLABLE &#8594;</div>
                    <div className="table-responsive">
                        <table className="table table-regular table-striped gig-listings">
                            <thead>
                                <tr>
                                    <th>DATE</th>
                                    <th>TIME</th>
                                    <th>EVENT NAME</th>
                                    <th>CITY</th>
                                    <th>VENUE</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {artist.Gigs && artist.Gigs.length > 0 ? 
                                    artist.Gigs.map((gig) => <SeeMeItem key={gig.ID} gig={gig} actions={actions} />)
                                : 
                                <tr>
                                    <td colSpan="6" style={{textAlign: 'center'}}>
                                        {(artist.GigsStatus == 'LOADING' ?
                                        <Loading /> : <div>No upcoming gigs at the moment</div>)}                                
                                    </td>
                                </tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
        );
    }
}

SeeMe.propTypes = {
    artist: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default SeeMe;